import { Container } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import React from 'react';

import {
	EntitySearchStatus,
	EntitySearchType,
} from '~/components/entity-search/entity-type';
import {
	EntityTypeUtils,
	SupportDetailItem,
} from '~/components/entity-search/entity-type-util';
import { NavigationSearchHistory } from '~/components/navigation/navigation-types';
import { EntityType } from '~/models/entities/entity-type';
import { Logger } from '~/utils/logger';

import { EntitySearchMainDetails } from '~/components/entity-search/entity-search-main-details/entity-search-main-details';

import styles from '~/components/entity-search/entity-search-result/entity-search-result.module.scss';

interface Props {
	index: number;
	data: EntitySearchType;
	onClick: (entity: EntitySearchType) => void;
	onKeyDown: (e: React.KeyboardEvent) => void;
}

export class EntitySearchResult extends React.Component<Props> {
	private readonly i18n: I18N = Container.instance.get(I18N);

	constructor(props) {
		super(props);
	}

	get suburb(): string {
		if (
			this.props.data &&
			this.props.data.entityType === EntityType.MEMBER &&
			this.props.data.values.D2z_Suburb
		) {
			return this.props.data.values.D2z_Suburb.trim();
		}
		return '';
	}

	get stateArea(): string {
		if (
			this.props.data &&
			this.props.data.entityType === EntityType.MEMBER &&
			this.props.data.values.D2z_State
		) {
			return this.props.data.values.D2z_State.trim();
		}
		return '';
	}

	get email(): string {
		if (
			this.props.data &&
			this.props.data.entityType === EntityType.MEMBER &&
			this.props.data.values.D2z_Email
		) {
			return this.props.data.values.D2z_Email.trim();
		}
		return '';
	}

	get homePhone(): string {
		if (
			this.props.data &&
			this.props.data.entityType === EntityType.MEMBER &&
			this.props.data.values.D2z_Home_Phone
		) {
			const phone = this.props.data.values.D2z_Home_Phone.trim();
			return this.i18n.tr('entity-search.home-phone', { phone });
		}
		return '';
	}

	get workPhone(): string {
		if (
			this.props.data &&
			this.props.data.entityType === EntityType.MEMBER &&
			this.props.data.values.D2z_Work_Phone
		) {
			const phone = this.props.data.values.D2z_Work_Phone.trim();
			return this.i18n.tr('entity-search.work-phone', { phone });
		}
		return '';
	}

	get mobilePhone(): string {
		if (
			this.props.data &&
			this.props.data.entityType === EntityType.MEMBER &&
			this.props.data.values.D2z_Mobile_Phone
		) {
			const phone = this.props.data.values.D2z_Mobile_Phone.trim();
			return this.i18n.tr('entity-search.mobile-phone', { phone });
		}
		return '';
	}

	private readonly onClick = (
		e: React.MouseEvent<HTMLButtonElement>,
	): void => {
		e.preventDefault();
		this.props.onClick(this.props.data);
	};

	public render() {
		const { index, onKeyDown } = this.props;
		const supportingDetails = EntityTypeUtils.getSupportingDetails(
			this.props.data,
		);
		return (
			<li>
				<button
					type="button"
					className={styles.button}
					onClick={this.onClick}
					onKeyDown={onKeyDown}
					data-index={index}
				>
					<EntitySearchMainDetails
						entity={this.props.data}
						size="small"
					/>
					{supportingDetails && supportingDetails.length > 0 && (
						<div className={styles['supporting-details']}>
							{supportingDetails.map((item) => {
								if (!item.displayValue) {
									return undefined;
								}
								let title = item.displayValue;
								if (item.description) {
									title += ' (' + item.description + ')';
								}
								return (
									<p
										key={item.displayValue + item.label}
										title={title}
									>
										<strong>{item.label}</strong>
										<span>
											<span>{item.displayValue}</span>
											{item.description ? (
												<span
													className={
														styles[
															'supporting-details-description'
														]
													}
												>
													{' '}
													({item.description})
												</span>
											) : undefined}
										</span>
									</p>
								);
							})}
						</div>
					)}
					<div className={styles['contact-details']}>
						{(this.suburb || this.stateArea) && (
							<p>
								<i
									className={[
										'fas',
										'fa-home',
										styles.icon,
									].join(' ')}
									aria-hidden="true"
								/>
								{this.suburb}
								{this.suburb ? ', ' : ''}
								{this.stateArea}
							</p>
						)}
						{this.email && (
							<p>
								<i
									className={[
										'fas',
										'fa-at',
										styles.icon,
									].join(' ')}
									aria-hidden="true"
								/>
								{this.email}
							</p>
						)}
						{(this.homePhone ||
							this.workPhone ||
							this.mobilePhone) && (
							<p>
								<i
									className={[
										'fas',
										'fa-phone',
										styles.icon,
									].join(' ')}
									aria-hidden="true"
								/>
								{this.homePhone && (
									<span>{this.homePhone}</span>
								)}
								{this.workPhone && (
									<span>{this.workPhone}</span>
								)}
								{this.mobilePhone && (
									<span>{this.mobilePhone}</span>
								)}
							</p>
						)}
					</div>
				</button>
			</li>
		);
	}
}
